import React from 'react';
import { connect } from 'react-redux';
import ExperimentContext from './ExperimentContext';

const ExperimentProvider = ({ experiments, children }) => (
  <ExperimentContext.Provider value={experiments}>
    {children}
  </ExperimentContext.Provider>
);

const mapStateToProps = ({ abacus }) => ({
  experiments: abacus.experiments
});

export default connect(mapStateToProps, null, null, { pure: false })(ExperimentProvider);



// WEBPACK FOOTER //
// ./src/universal/components/Experiment/ExperimentProvider.js